import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { ArrowRight, Clock as ClockIcon, Signal } from "lucide-react";
import { Layout } from "../components/Layout";
import { LotusMark } from "../components/Logo";
import { programs } from "../data/programs";

export const ProgramsPage = () => {
  return (
    <Layout>
      <section className="pt-28 md:pt-32 pb-12">
        <div className="container mx-auto px-6 text-center max-w-3xl">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-widest mb-5">
            <LotusMark className="w-4 h-4" /> Programs &amp; Courses
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal mb-4">
            Yoga for every stage of life
          </h1>
          <p className="text-charcoal/70 text-lg">
            From conception to seniors — explore our programs and find the
            practice that fits you. Tap any card for details.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {programs.map((p) => (
              <RouterLink
                key={p.slug}
                to={`/programs/${p.slug}`}
                className="group bg-white rounded-3xl overflow-hidden border border-accent/15 shadow-soft hover:-translate-y-1.5 hover:shadow-soft-lg transition-all flex flex-col"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="font-heading text-xl text-charcoal mb-2">
                    {p.title}
                  </h2>
                  <p className="text-sm text-charcoal/65 leading-relaxed mb-4 flex-1">
                    {p.summary}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-charcoal/55 mb-4">
                    <span className="inline-flex items-center gap-1.5">
                      <ClockIcon className="w-3.5 h-3.5" /> {p.duration}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <Signal className="w-3.5 h-3.5" /> {p.level}
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-primary font-semibold text-sm group-hover:gap-2.5 transition-all">
                    View details <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </RouterLink>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ProgramsPage;
